import { ItemRelationsFragment } from '@/integrations/crystallize/__gql-codegen-types/catalogue/graphql';
import { ArrayElementType } from '@/integrations/crystallize/types/helpers/ArrayElementType';
import { DocShapeId } from '@/utils/shapeIds';

export function extractAnchorIdFromTile(
  tile: ArrayElementType<ItemRelationsFragment['items']> | undefined,
): string | undefined | null {
  if (!tile) {
    return undefined;
  }
  const anchorTileShape = tile.shape.identifier;

  if (anchorTileShape === DocShapeId.anchorTile) {
    return tile?.components?.[0]?.content?.__typename === 'SingleLineContent'
      ? tile?.components?.[0]?.content?.text
      : undefined;
  }

  if (anchorTileShape === DocShapeId.faq) {
    return tile.id;
  }

  return undefined;
}
